import { FunctionComponent, useEffect } from "react";
import TextInputField from "../../Components/TextInput/TextInputField";
import { ErrorMessage, FormikProps, useFormik } from "formik";
import Select from "../../Components/Select/Select";
import { IVehicleList } from "./Ivehicle";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import * as Yup from "yup";
import {
  addMaster,
  clearAddMasterState,
} from "../../Redux/Slicers/Master/AddMasterSlicer";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import {
  clearUpdateMasterState,
  updateMaster,
} from '../../Redux/Slicers/Master/UpdateMasterSlicer';
import { addVehicle, clearAddVehicleState } from "../../Redux/Slicers/Vehicle/AddVehicleSlicer";
import { clearUpdateVehicleState, updateVehicle } from "../../Redux/Slicers/Vehicle/UpdateVehicleSlicer";
import UploadButtonField from "../../Components/Button/UploadButtonField";
import FormHelperText from "@mui/material/FormHelperText";
import SvgIcon from "@mui/material/SvgIcon";
import { Upload } from "@mui/icons-material";

interface MasterFormProps {
  vehicleForm: (data: FormikProps<any>) => void;
}

const VehicleForm: FunctionComponent<MasterFormProps> = (props) => {
  const dispatch = useAppDispatch();
  const { updateableDate } = useAppSelector((state) => state.UpdateVehicle);
  const { data: projectData } = useAppSelector((state) => state.Master);
  const validationSchema1 = Yup.object().shape({
    vehicle_plate_no: Yup.string().required("Please enter vehicle no"),
    RFID: Yup.string().optional().nullable().notRequired(),
    // vehicle_type: Yup.string().required('Please choose Vehicle type'),
    // phone: Yup.string().required('Please enter Contact Number'),
    registration_name: Yup.string().required("Please enter Registration Name"),
    status: Yup.string().required("Please select Status"),
    file: Yup.mixed()
      .optional()
      .nullable()
      .test(
        "type",
        "Only the following formats are accepted: .jpeg, .jpg,svg and .png",
        (value: any) => {
          // If no file is provided, validation passes (field is optional)
          if (!value || value === "" || typeof value === "string") return true;
          // If file is provided, validate the file type
          return (
            value.type === "image/jpeg" ||
            value.type === "image/png" ||
            value.type === "image/svg+xml" ||
            value.type === "image/jpg"
          );
        }
      ),
  });

  const validationSchema = Yup.object().shape({
    vehicle_plate_no: Yup.string().required("Please enter vehicle no"),
    RFID: Yup.string().optional().nullable().notRequired(),
    // phone: Yup.string().required('Please enter Contact Number'),
    // vehicle_type: Yup.string().required('Please choose Vehicle type'),
    registration_name: Yup.string().required("Please enter Registration Name"),
    user_id: Yup.string().required("Please select user"),
    //   : Yup.string().nullable(),

    status: Yup.string().required("Please select Status"),
    file: Yup.mixed()
      .optional()
      .nullable()
      .test(
        "type",
        "Only the following formats are accepted: .jpeg, .jpg,svg and .png",
        (value: any) => {
          // If no file is provided, validation passes (field is optional)
          if (!value || value === "" || typeof value === "string") return true;
          // If file is provided, validate the file type
          return (
            value.type === "image/jpeg" ||
            value.type === "image/png" ||
            value.type === "image/svg+xml" ||
            value.type === "image/jpg"
          );
        }
      ),
  });
  const vehicleFrom = useFormik({
    initialValues,
    validationSchema: updateableDate ? validationSchema1 : validationSchema,
    onSubmit: (value) => {
      if (updateableDate && Object.keys(updateableDate).length !== 0) {
        console.log("update", value);

        dispatch(updateVehicle({ ...value, id: updateableDate._id, isAdminpanel: true }));
      } else {
        dispatch(addVehicle({ ...value, isAdminpanel: true }));
      }
    },
  });

  useEffect(() => {
    props.vehicleForm(vehicleFrom);
    if (updateableDate) {
      vehicleFrom.setFieldValue(
        "vehicle_plate_no",
        updateableDate.vehicle_plate_no
      );
      vehicleFrom.setFieldValue("RFID", updateableDate.RFID);
      vehicleFrom.setFieldValue(
        "registration_name",
        updateableDate.registration_name
      );
      vehicleFrom.setFieldValue("status", updateableDate.status);
      vehicleFrom.setFieldValue("file", updateableDate.vehicle_image);
      // vehicleFrom.setFieldValue('vehicle_type', updateableDate.vehicle_type);
      vehicleFrom.setFieldValue("user_id", updateableDate.user_id?._id || "");
      // vehicleFrom.setFieldValue('phone', updateableDate.phone);
    }
    return () => {
      dispatch(clearAddVehicleState());
      dispatch(clearUpdateVehicleState());
      vehicleFrom.resetForm();
    };
  }, [updateableDate]);
  const data1 = projectData?.response?.data;
  const projects = Array.isArray(data1)
    ? data1.map((project) => ({
        label: project.phone + "_" + project.first_name,
        value: project._id!,
      }))
    : [];

  return (
    <form
      className="master_form"
      onSubmit={vehicleFrom.handleSubmit}
      onReset={vehicleFrom.handleReset}
      autoComplete="off">
      <TextInputField
        inputClassName="uppercase"
        id="vehicle_plate_no"
        name="vehicle_plate_no"
        label="Vehicle Number"
        value={vehicleFrom.values.vehicle_plate_no}
        onChange={vehicleFrom.handleChange}
        onBlur={vehicleFrom.handleBlur}
        helperText={
          vehicleFrom.touched.vehicle_plate_no &&
          vehicleFrom.errors.vehicle_plate_no
        }
        error={
          vehicleFrom.touched.vehicle_plate_no &&
          Boolean(vehicleFrom.errors.vehicle_plate_no)
        }
      />
      {/* <Select
        id="vehicle_type"
        name="vehicle_type"
        label="Vehicle Type"
        value={vehicleFrom.values.vehicle_type}
        options={["Car", "Bike", "SUV", "Truck", "Van", "Bus", "Auto"]}
        onChange={(_, value) => {
          vehicleFrom.setFieldValue("vehicle_type", value);
        }}
        onBlur={vehicleFrom.handleBlur}
        helperText={
          vehicleFrom.touched.vehicle_type && vehicleFrom.errors.vehicle_type
        }
        error={
          vehicleFrom.touched.vehicle_type &&
          Boolean(vehicleFrom.errors.vehicle_type)
        }
        placeholder="-select-"
      /> */}
      <Select
        id="user_id"
        name="user_id"
        label="User Name"
        disabled={updateableDate && Object.keys(updateableDate).length !== 0}
        // value={projects?.find(
        //   (project) => project.value === vehicleFrom.values._id
        // )}
        value={
          updateableDate && Object.keys(updateableDate).length !== 0 && updateableDate.user_id
            ? {
                label:
                  updateableDate.user_id.phone +
                  "_" +
                  updateableDate.user_id.first_name,
                value: updateableDate.user_id._id,
              }
            : projects?.find(
                (project) => project.value === vehicleFrom.values.user_id
              )
        }
        options={projects}
        isOptionEqualToValue={(option, value) => {
          if (typeof option === 'string' || typeof value === 'string') {
            return option === value;
          }
          const opt = option as AutocompleteOption;
          const val = value as AutocompleteOption;
          return opt?.value === val?.value;
        }}
        onChange={(_, value) => {
          const projectValue = value as AutocompleteOption;
          vehicleFrom.setFieldValue("user_id", projectValue?.value);
        }}
        onBlur={vehicleFrom.handleBlur}
        helperText={
          vehicleFrom.touched.user_id && Boolean(vehicleFrom.errors.user_id)
        }
        error={
          vehicleFrom.touched.user_id && Boolean(vehicleFrom.errors.user_id)
        }
        // helperText={vehicleFrom.touched._id && vehicleFrom.errors._id}
        // error={vehicleFrom.touched._id && Boolean(vehicleFrom.errors._id)}
        placeholder="-select-"
      />

      {/* <TextInputField
      id="phone"
      name="phone"
      label="Contact Number"
      value={vehicleFrom.values.phone}
      onChange={(event) => {
        vehicleFrom.setFieldValue(
          'phone',
          event.target.value.replace(/[^0-9.]/g, '')
        );
      }}
      onBlur={vehicleFrom.handleBlur}
      helperText={vehicleFrom.touched.phone && vehicleFrom.errors.phone}
      error={vehicleFrom.touched.phone && Boolean(vehicleFrom.errors.phone)}
    /> */}
      <TextInputField
        id="RFID"
        name="RFID"
        label="RFID"
        value={vehicleFrom.values.RFID}
        onChange={vehicleFrom.handleChange}
        onBlur={vehicleFrom.handleBlur}
        helperText={vehicleFrom.touched.RFID && vehicleFrom.errors.RFID}
        error={vehicleFrom.touched.RFID && Boolean(vehicleFrom.errors.RFID)}
      />

      <TextInputField
        id="registration_name"
        name="registration_name"
        label="Register Name"
        value={vehicleFrom.values.registration_name}
        onChange={vehicleFrom.handleChange}
        onBlur={vehicleFrom.handleBlur}
        helperText={
          vehicleFrom.touched.registration_name &&
          vehicleFrom.errors.registration_name
        }
        error={
          vehicleFrom.touched.registration_name &&
          Boolean(vehicleFrom.errors.registration_name)
        }
      />
      <UploadButtonField
        className="upload_field"
        name="file"
        onChange={(event) => {
          if (event.target.files?.length) {
            vehicleFrom.setFieldValue("file", event.target.files[0]);
          }
        }}
        onBlur={vehicleFrom.handleBlur}
        fileAccept="image/jpeg,image/png,image/svg+xml,image/jpg">
        {vehicleFrom.values.file ? (
          <img
            src={
              typeof vehicleFrom.values.file === "string"
                ? `${process.env.REACT_APP_API_URL}/${vehicleFrom.values.file}`
                : URL.createObjectURL(
                    vehicleFrom.values.file as unknown as File
                  )
            }
            alt="file"
            height={168}
          />
        ) : (
          <>
            <SvgIcon
              component={Upload}
              inheritViewBox
            />
            Supported Format : (1000 x 1000 px) <br /> png, jpg, svg, jpeg
          </>
        )}
      </UploadButtonField>
      {vehicleFrom.touched.file && vehicleFrom.errors.file && (
        <FormHelperText error={true}>
          {vehicleFrom.errors.file}
        </FormHelperText>
      )}

      <Select
        id="status"
        name="status"
        label="Status"
        value={
          vehicleFrom.values.status === null ||
          vehicleFrom.values.status === undefined
            ? "Active"
            : vehicleFrom.values.status
            ? "Active"
            : "In-active"
        }
        options={["Active", "In-active"]}
        onChange={(_, value) => {
          vehicleFrom.setFieldValue(
            "status",
            value === null ? null : value === "Active"
          );
        }}
        onBlur={vehicleFrom.handleBlur}
        helperText={vehicleFrom.touched.status && vehicleFrom.errors.status}
        error={vehicleFrom.touched.status && Boolean(vehicleFrom.errors.status)}
        placeholder="-select-"
      />

      <button
        type="submit"
        style={{ display: "none" }}
      />
    </form>
  );
};

export default VehicleForm;

const initialValues: IVehicleList = {
  id: "",
  vehicle_plate_no: "",
  vehicle_type: "",
  brand: "",
  model: "",
  colour: "",
  registration_name: "",
  phone: "",
  purpose: "",
  file: "",
  _id: "",
  user_id: {
    _id: "",
    uid: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    profile_pic_url: "",
    r_id: "",
    activated: false,
    last_ip: "",
    last_login: "",
    status: false,
    is_deleted: false,
    deletedt: null,
    created_at: "",
    updated_at: "",
    __v: 0,
    customerId: "",
  },
  RFID: "",
  status: false,
  is_deleted: false,
  deletedat: null,
  created_at: "",
  updated_at: "",
  __v: 0,
  key: "",
};
